
export type CommandCall = [string, any[]];
export type CommandScript = readonly CommandCall[];

export class CommandSymbol {
    constructor(public readonly value: string) {
    }
    public toString() {
        return this.value;
    }
}

export const CommandScript = Object.freeze({
    parse(cs: string): CommandScript {

        const lines = cs
            .split(/\n/g)
            .map(x => x.trim())
            .filter(x => !!x);

        const calls = [] as CommandCall[];

        for (const ln of lines) {
            const [command, ...args] = stringSplitAckQuotes(ln);
            const input = args.map(processArg);
            calls.push([command, input]);
        }

        return Object.freeze(calls);
    },
});

// Source: https://stackoverflow.com/questions/16261635/javascript-split-string-by-space-but-ignore-space-in-quotes-notice-not-to-spli
const stringSplitAckQuotes = (str: string) =>
    str.match(/\\?.|^$/g).reduce((p, c) => {
        if (c === '"') {
            p.quote ^= 1;
        }
        else if (!p.quote && c === ' ') {
            p.a.push('');
        }
        else {
            p.a[p.a.length - 1] += c.replace(/\\(.)/, '$1');
        }
        return p;
    }, { quote: undefined as number, a: [''] }).a;

const processArg = (arg: string): any => {
    try { return JSON.parse(arg); }
    // catch { return new CommandSymbol(arg); }
    catch { return arg; }
};
